// crewbit-admin/src/lib/recordPaymentMutations.ts
//
// §Money.StubActionSweepCompletion Phase 3 — standalone payment-recording
// wrapper. Extracted from invoiceMutations.ts to keep that file under the
// Golden Rule #14 500-line cap.
//
// `record_manual_invoice_payment` is conceptually distinct from
// `set_invoice_paid_manually` (which is `markPaidManually` in invoiceMutations):
// this RPC writes the payment_ledger row directly and uses RAISE EXCEPTION
// for errors (raw strings), so `mapPostgresError` surfaces them as
// UNKNOWN-shape MoneyError envelopes rather than structured codes.
//
// Method choices restricted to cash | cheque | etransfer | other (see RPC body).
// Card/debit go through markPaidManually (set_invoice_paid_manually) instead.

import { callMoneyRpc, type MoneyRpcResult } from './moneyRpc';
import { MONEY_MUTATION_EVENT } from '../hooks/useFinancialSummary';

export interface RecordManualInvoicePaymentArgs {
  invoiceId: string;
  amount: number;
  method: 'cash' | 'cheque' | 'etransfer' | 'other';
  /** ISO timestamp; defaults server-side if omitted. */
  receivedAt: string;
  notes?: string | null;
}

export async function recordManualInvoicePayment(
  args: RecordManualInvoicePaymentArgs,
): Promise<MoneyRpcResult<{ invoice_id: string; ledger_id?: string; already_paid?: boolean }>> {
  const result = await callMoneyRpc<{
    invoice_id: string;
    ledger_id?: string;
    already_paid?: boolean;
  }>('record_manual_invoice_payment', {
    p_invoice_id: args.invoiceId,
    p_amount: args.amount,
    p_method: args.method,
    p_received_at: args.receivedAt,
    p_notes: args.notes ?? null,
  });
  if (result.success) {
    window.dispatchEvent(new Event(MONEY_MUTATION_EVENT));
  }
  return result;
}
